module.exports = __webpack_public_path__ + "img/icon_detials.d4ced0ee.svg";